import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { isURL } from 'validator';

import ConfirmAction from './ConfirmAction';
import InputUrl from './import_rss/InputUrl';
import Items from './import_rss/Items';
import fetchUrl from '../lib/fetchUrl';
import { useDebouncedEffect  } from '../lib/debounce';

const ImportUrl = (props) => {
  const storage = window.localStorage;
  const [open, setOpen] = useState(false);
  const [url, setUrl] = useState(storage.getItem('md:import_url:url') || '');
  const [isStartFetching, setIsStartFetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isProblem, setIsProblem] = useState(null);

  const callbackRef = useRef();
  const elmRef = useRef();

  useEffect(() => {
    window.openImportUrl = (callback) => {
      setOpen(true);
      callbackRef.current = (value) => callback(value);
    }
  });

  useEffect(() => {
    setIsStartFetching(false);
    setIsProblem(null);
    storage.setItem("md:import_url:url", url);
  }, [url]);

  useDebouncedEffect(() => {
    if(isStartFetching === false) return;

    const urlRss = url.trim();
    if(!isURL(urlRss)) {
      setIsProblem(i18n.t('import_html.wrong_url'));
      setIsLoading(false);
      setIsStartFetching(false);

      return;
    }

    setIsLoading(true);
    const [promise, abort] = fetchUrl(props.url, { url });
    promise
      .then((data) => {
        setIsLoading(false);
        setIsProblem(null);
        setContent(data.html);
        setOpen(false);
        setIsStartFetching(false);
      })
      .catch((err) => {
        if (err.name === 'AbortError'){
          console.log('aborted')
        } else {
          setIsProblem(i18n.t('import_html.problem'));
          setIsLoading(false);
          setIsStartFetching(false);
        }
        return;
      });

    return () => abort && abort();
  }, 100, [isStartFetching]);


  const setContent = value => {
    callbackRef.current(value);
  }

  const onReject = (e) => {
    e.stopPropagation();
    callbackRef.current('');
    setOpen(false);
  }

  const htmlDecode = (value) => {
    // const elem = document.createElement('textarea');
    // elem.innerHTML = value;

    // return elem.value;
    return value.replace(/&quot;/g, "'");
  }

  const onAccept = (e) => {
    e.stopPropagation();
    setIsStartFetching(true);

    return false;
  }

  const wrapperClasses = classNames(
    'import-rss',
    {
      'import-rss--wait': isLoading
    }
  );

  const renderItem = (item, index) => {
    return (<div>{item.title}</div>);
  }

  const insertStatus = () => {
    if(isLoading) {
      return 'loading';
    }else{
      return 'load';
    }
  };

  const insertText = () => {
    switch(insertStatus()){
      case 'load':
        return i18n.t('import_html.load');
      case 'loading':
        return i18n.t('import_html.loading');
      default:
        return '---';
    }
  };

  const disabled = ['choice', 'loading'].includes(insertStatus());

  return (
    <div className={wrapperClasses} ref={elmRef}>
    { open &&
      <ConfirmAction
        onAccept={onAccept}
        onReject={onReject}
        textReject={ i18n.t('import_html.cancel') }
        textAccept={insertText()}
        disabled={disabled}
      >
        <h3 className="import-rss__title">{ i18n.t('import_html.title') }</h3>
        <InputUrl value={url} onChange={value => setUrl(value)}
          placeholder={ i18n.t('import_html.placeholder_url') } error={isProblem} />
        <div className="preloader" />
      </ConfirmAction>
    }
    </div>
  );
}
export default ImportUrl;
